import { useContext } from 'react';
import { SourceAccountsContext } from './sourceAccountsContext';
export const useSourceAccounts = () => {
  const context = useContext(SourceAccountsContext);
  if (!context) {
    throw new Error("useSourceAccounts must be used within a SourceAccountsProvider");
  }
  return context;
};